import { Box, Collapse } from "@mui/material";
import ContentAdmin from "components/contentAdmin";
import { ReactComponent as SVGChevron } from "assets/images/icons/size-24/chevron.svg";
import IMGSectionBackground from "../../assets/images/section-background.jpg";

type SectionThreeProps = {
	expandedAccordion: number;
	setExpandedAccordion(value: 0 | 1 | 2): void;
};

function SectionThree({ expandedAccordion, setExpandedAccordion }: SectionThreeProps)
{
	const accordionDataList = [
		{
			title: (
				<ContentAdmin
					keyText="mission-one-firstComplete"
					keyContent="section3-accordions1-title"
					defaultValue="Is it for me?"
					position="left"
				/>
			),
			desc: (
				<ContentAdmin
					keyText="mission-one-firstComplete"
					keyContent="section3-accordions1-desc"
					defaultValue="**The quest is for you if:**\n- Not sure in which direction you want to go in life\n- Don't know what to do with your life\n- Not sure what career to choose\n- Don't know what your passions are\n- Need to make big life choices\n- You love structure & want to organise your life"
					position="left"
					isDescription
				/>
			)
		},
		{
			title: (
				<ContentAdmin
					keyText="mission-one-firstComplete"
					keyContent="section3-accordions2-title"
					defaultValue="Why should I do it?"
					position="left"
				/>
			),
			desc: (
				<ContentAdmin
					keyText="mission-one-firstComplete"
					keyContent="section3-accordions2-desc"
					defaultValue="**By doing the quest you will:**\n- Understand yourself: your values, beliefs, fears, dreams and desires\n- Empty your head & organise your life\n- Prioritise your goals & objectives\n- Build a strategic life plan\n- Get unstuck and find the courage to make a change\n- Maximise who you are and create an extraordinary life"
					position="left"
					isDescription
				/>
			)
		},
		{
			title: (
				<ContentAdmin
					keyText="mission-one-firstComplete"
					keyContent="section3-accordions3-title"
					defaultValue="How does it work?"
					position="left"
				/>
			),
			desc: (
				<ContentAdmin
					keyText="mission-one-firstComplete"
					keyContent="section3-accordions3-desc"
					defaultValue="**Here is what to expect:**\n- It is a profound, serious journey, so you need to be ready to put in real work if you want to get the results\n- You will have 10 missions, each requiring 20-40 minutes of your time\n- Your virtual mentor Octa will guide you through answering big life questions\n- We help you connect the dots & take actions from your insights\n- You will need a computer to access this web-based journey\n- Do it anytime, anywhere, pause and resume when you want"
					position="left"
					isDescription
				/>
			)
		}
	];

	return (
		<Box
			component="section"
			sx={{
				paddingBottom: { xl: "80px", lg: "56px", xs: "40px" },
				background: `url(${ IMGSectionBackground }) center center / cover`,
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				gap: "28px"
			}}
		>
			{accordionDataList.map(({ title, desc }, index) => (
				<Box
					key={index}
					sx={{
						overflow: "hidden",
						position: "relative",
						maxWidth: "752px",
						width: "100%",
						backgroundColor: "#FFFFFF",
						borderRadius: "24px",
						color: "primary.main",

						"& button": {
							width: "100%",
							height: { xl: "96px", lg: "68px", xs: "52px" },
							padding: { xl: "0 32px 0 36px", lg: "0 24px", xs: "0 24px" },
							backgroundColor: "unset",
							border: "unset",
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							gap: { xl: "20px", lg: "12px" },
							font: { xl: "700 24px 'Open Sans'", xs: "700 18px 'Open Sans'" },
							color: "inherit",
							cursor: "pointer",
							"& svg": {
								"--size": { xl: "24px", lg: "17px", xs: "14px" },
								width: "var(--size)",
								height: "var(--size)",
								transition: "linear 200ms transform",
								transform: {
									xl: `translateY(4.5px) rotate(${ expandedAccordion === index ? "-180deg" : "0deg" })`,
									lg: `translateY(2.5px) rotate(${ expandedAccordion === index ? "-180deg" : "0deg" })`,
									xs: `rotate(${ expandedAccordion === index ? "-180deg" : "0deg" })`
								}
							}
						},
						"& .content": {
							margin: "unset",
							padding: {
								xl: "0 36px 46px 36px",
								lg: "0 24px 32px 24px",
								xs: "0 24px 24px 24px"
							},
							font: { xl: "400 22px 'Open Sans'", xs: "400 16px 'Open Sans'" },
							"& ul": {
								paddingLeft: "28px"
							}
						}
					}}
				>
					<button
						type="button"
						onClick={() => setExpandedAccordion(index as 0 | 1 | 2)}
					>
						<span>{title}</span>
						<SVGChevron />
					</button>

					<Collapse in={expandedAccordion === index}>
						<div className="content">{desc}</div>
					</Collapse>
				</Box>
			))}
		</Box>
	);
}

export default SectionThree;
